<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import "@/assets/css/global.css";

export default {
  name: 'App',
  components: {},
}
</script>

<style></style>
